import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=06cd4cff&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=06cd4cff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd4cff",
  null
  
)

export default component.exports